"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _resizeSpy = _interopRequireDefault(require("./utils/resizeSpy"));
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __DEV__ = process.env.NODE_ENV && process.env.NODE_ENV === "development";
function RenderItem(props) {
    var item = props.item;
    var ref = _slicedToArray((0, _react).useState(0), 2), opacity = ref[0], setOpacity = ref[1];
    var ref1 = (0, _react).useRef(null);
    (0, _react).useLayoutEffect(function() {
        requestAnimationFrame(function() {
            setOpacity(1);
        });
    }, []);
    (0, _react).useEffect(function() {
        if (!ref1.current) return;
        var disposer = _resizeSpy.default.watch(ref1.current, function(layout) {
            if (!ref1.current) return;
            props.store.setItemLayout(item.item, layout);
        });
        return function() {
            if (disposer) disposer();
        };
    }, [
        item.area.size,
        item.index,
        item.item,
        props.direction,
        props.store
    ]);
    var style = {
        opacity: opacity
    };
    if (props.direction === 'vertical') {
        style.top = item.area.start + 'px';
        style.height = 'auto';
        style.width = '100%';
    } else {
        style.left = item.area.start + 'px';
        style.width = 'auto';
        style.height = '100%';
    }
    var attrs = {};
    if (__DEV__) attrs['data-size'] = item.area.size;
    return /*#__PURE__*/ _react.default.createElement("div", _extends({
        className: "lazylist-item",
        style: style,
        ref: ref1
    }, attrs), props.children);
}
var _default = /*#__PURE__*/ _react.default.memo(RenderItem);
exports.default = _default;
